import React, { useMemo } from "react";
import { Tooltip, Whisper, IconButton } from "rsuite";
import { TypeAttributes } from "rsuite/esm/@types/common";
import { StationConnectionResult } from "@containers/Station/interfaces";

import "./index.scss";
import { Icon } from "../Icon";
import { QualitySignal } from "../QualitySignal";

export interface ConnectionStatusProps {
  item: string;
  connections: Record<string, StationConnectionResult> | null;
  isConnectionsLoading: boolean;
  placement?: TypeAttributes.Placement;
  onRefreshConnections: (code: string) => void;
}

const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  connections,
  item,
  onRefreshConnections,
  isConnectionsLoading,
  placement = "auto",
}) => {
  const connection = useMemo(() => {
    if (!connections) return null;

    return connections[item] || null;
  }, [connections, item]);

  const isSynced = useMemo(() => {
    return connection ? connection.is_synced_with_remote_sdh : false;
  }, [connection]);

  const syncIconName = useMemo(() => {
    return isSynced ? "cloud-success" : "cloud-failed";
  }, [isSynced]);

  const syncTooltipText = useMemo(() => {
    if (isSynced) {
      return "Synchronization was successful with the remote SDH.";
    }

    return "Synchronization failed with the remote SDH.";
  }, [isSynced]);

  return (
    <div className="connection-status-block">
      <QualitySignal quality={connection?.quality || 0} text={item} />
      <Whisper trigger="hover" placement={placement} controlId="sync" speaker={<Tooltip>{syncTooltipText}</Tooltip>}>
        <div>
          <Icon type={syncIconName} className="sync-icon" />
        </div>
      </Whisper>
      <IconButton
        loading={isConnectionsLoading}
        icon={<Icon type="reload" />}
        onClick={() => onRefreshConnections(item)}
      />
    </div>
  );
};

export default ConnectionStatus;
